import { TmApiValidationError } from '@/core/error/transport/tmApiValidationError'

export class TmByocBandwidthUCTrunkingNotSupported extends TmApiValidationError {
  public name = 'TmByocBandwidthUCTrunkingNotSupported'
}
